import React from 'react';
import ReactDOM from 'react-dom';
import FormItemEditor from './FormItemEditor';
import FormItemConst from './FormItemConst';
import {RecordFieldChangeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';

require("bootstrap-select");
require("bootstrap-select/dist/css/bootstrap-select.css");
require("../styles/FormItemEnumStyle.css");


export default class FormItemEnumEditor extends FormItemEditor
{
	constructor(props) {
		super(props);
		if(!this.props.forLookup)
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		if(!this.props.forLookup)
		{
			this.unsubscribeRecordFieldChangeStore();
		}
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;			
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = this.record?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			
			
			$(this.inputField).selectpicker('val',_value);

			if(this.props.control)
			{

				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
			//$(this.inputField).val(_value);
		}
	}

	inputFieldFocus(e)
	{
		window.lastFocusUI = this.inputField;
		if(this.props.underQueryGroup){
			this.setState({allowEdit:true});
		}
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		//alert("EnumEditor inputFieldFocus");
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
	}

	

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			//$(this.inputField).val(newValue);
			$(this.inputField).selectpicker('val',newValue);
			this.updateModifiedTag();
		}
	}

	onKeyDownHandler(e)
	{
		if(super.onKeyDownHandler(e) == false)
		{
			if(e.ctrlKey && e.keyCode == 40)
			{
				$(this.inputField).selectpicker('show');
			}
		}
	}
	inputFieldBtnClick(){
		if(this.state.allowEdit){
			return;
		}
		this.setState({allowEdit:true})
		this.inQueryGroup = true;
		$(this.inputField).parent().find("button.btn").click();

	}
	// inputFieldBlur(){
	// 	let value = $(this.inputField).val();
	// 	if(value=='' || !value || value==['']){
	// 		this.setState({allowEdit:false});
	// 		this.inQueryGroup=false;
	// 	}
	// }

	componentDidMount()
	{
		super.componentDidMount();
		$(this.contextMenuHandler).contextPopup(this.props.contextMenuData);
		if(this.props.height)
		{
			$(this.contextMenuHandler).children('div.bootstrap-select').css("height",this.props.height+'px');
		}
		
		//var sid = $(this.inputField).select2();
		//sid.val("12").trigger("change").on('change',this.selectedChanged.bind(this));
		let inputWidth = this.props.displayLengthWidth + "px";
		let displayLength=this.props.displayLength;
		let widthProValue = this.props.control.getProperty_Width();
		
		let _width;
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			_width = widthProValue;
		}
		else
		{
			_width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon+'px';
		}
		if(this.props.underQueryGroup){
			_width = _width.replace('px','');
			_width=parseInt(_width)+25+'px';
			$(this.inputField).selectpicker({width:_width,height:(this.props.height?this.props.height:'22.5')+'px',noneSelectedText: '-点此填值-',container:'body',
													liveSearch:false,noneResultsText: '没有找到匹配项'});
			$(this.inputField).parent().find("button.btn")
				.keydown(this.onKeyDownHandler.bind(this))
				//只有在点击的时候才出发focus
				.focus(this.inputFieldFocus.bind(this))
				.click(this.inputFieldBtnClick.bind(this))
				
		}else{
			$(this.inputField).selectpicker({width:_width,height:(this.props.height?this.props.height:'22.5')+'px',noneSelectedText: '未选中',container:'body',
													liveSearch:false,noneResultsText: '没有找到匹配项'});
			$(this.inputField).parent().find("button.btn")
				.keydown(this.onKeyDownHandler.bind(this))
				//只有在点击的时候才出发focus
				.focus(this.inputFieldFocus.bind(this));

		}
		//,style:"text-align:"+this.props.textAlign.toLowerCase()TODO有需求再通过修改源代码支持EnumEditor对AlignMent的支持
		//$(this.inputField).parent().focus(this.inputFieldFocus.bind(this));

		if(this.props.underQueryGroup)
		{

			this.doSetEnable(false);

		}
		else
		{
			let _initRecord;
			if(this.props.dataField)
			{
				_initRecord = this.props.initRecord;
			}
			else
			{
				if(this.props.control.hasInitEditorValue)
				{
					_initRecord = this.props.initEditorValue;	
				}
				else
				{
					_initRecord = this.props.initRecord;
				}
				
			}
			this.onCurrentRecordChanged(null,_initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		}

		//this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias);
		if(!this.props.groupAlias)
		{
			this.doUpdateAllowEditByJquery(this.state.allowEdit);
		}
	}

	doSetEnable(enable)
	{
		this.setState({allowEdit:enable});
		/*var nowAllowEdit = $(this.inputField).attr("disabled")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}*/
	}

	doUpdateAllowEditByJquery(allowEdit)
	{
		if(allowEdit == false)
		{
			let $dom = $(this.inputField).parent().find("button.btn");
			$dom.css("background-color",FormItemConst.EDITOR_NOTEDIT_COLOR).css("cursor","not-allowed");
			$(this.inputField).attr("disabled","");

			if(this.state.color && this.state.color != -1)$dom.css("color",this.state.color);else $dom.css("color","");
			if(this.state.fontSize && this.state.fontSize != -1)
			{
				$dom.find(".filter-option").css("font-size",this.state.fontSize);
			}
			else 
			{
				$dom.find(".filter-option").css("font-size","");
			}
			$(this.inputFieldIcon).css('display','none');
			if(this.state.fontFamily)$dom.css("font-family",this.state.fontFamily);else $dom.css("font-family","");
			if(this.state.fontWeight)$dom.css("font-weight",this.state.fontWeight);else $dom.css("font-weight","");
			if(this.props.underQueryGroup){
				$(this.inputFieldIcon).css('display','none');
				if(!$(this.inputField).val() || !$(this.inputField).val()[0]){
					$dom.find(".filter-option").text("-点此填值-");
				}
			}
			//$(this.inputField).parent().find("button.btn>span.pull-left").css("text-align","left");
		}
		else
		{
			let $dom = $(this.inputField).parent().find("button.btn");
			$dom.css("cursor","pointer");
			$(this.inputField).removeAttr("disabled");
			if(this.state.color && this.state.color != -1)$dom.css("color",this.state.color);else $dom.css("color","");
			if(this.state.backgroundColor && this.state.backgroundColor != -1)$dom.css("backgroundColor",this.state.backgroundColor);else $dom.css("backgroundColor","");
			if(this.state.fontSize && this.state.fontSize != -1)
			{
				$dom.find(".filter-option").css("font-size",this.state.fontSize);
			}
			else 
			{
				$dom.find(".filter-option").css("font-size","");
			}
			
			if(this.state.fontFamily)$dom.css("font-family",this.state.fontFamily);else $dom.css("font-family","")
			if(this.state.fontWeight)$dom.css("font-weight",this.state.fontWeight);else $dom.css("font-weight","");
			if(this.props.underQueryGroup){
				$(this.inputFieldIcon).css('display','');
				if(!$(this.inputField).val() || !$(this.inputField).val()[0]){
					$dom.find(".filter-option").text("");
				}
			}
		}
			
	}

	componentDidUpdate()
  	{
		this.doUpdateAllowEditByJquery(this.state.allowEdit);
		if(this.props.height)
		{
			$(this.contextMenuHandler).children('div.bootstrap-select').css("height",this.props.height+'px');
		}
  	}


	selectedChanged(e)
	{
		//todo 校验 需要考虑是否可编辑 将来有可能被放到Dialog及查询器上
		this.setFinalValue();
	}

	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		$(this.inputField).selectpicker('val',value);
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			var elem = $(this.inputField).parent().find("button.btn");
			
			elem.focus();
			//由于不会触发focus事件 所以要手动调用
			this.inputFieldFocus();
			//setTimeout(function(){elem.focus();},100);
		}
	}

	setFinalValue(value,triggerModified = true)
	{
		if(!value)
			value = $(this.inputField).val();
		if(this.props.underQueryGroup && !this.state.oldQueryValue){
			this.state.oldQueryValue=value;
		}
		if(!this.props.dataField)
		{
			if(this.props.underQueryGroup){
				if(this.state.oldQueryValue.indexOf('null') == -1 && value.indexOf('null') != -1){
					$(this.inputField).val(['null'])
					value=['null'];
					$(this.inputField).selectpicker('val',['null']);
				}
				if(this.state.oldQueryValue.indexOf('null') != -1 && value.length>1 ){
					value.splice(0,1);
					$(this.inputField).val(value)
					$(this.inputField).selectpicker('val',value);
				}
				if(this.props.underQueryGroup ){
					this.state.oldQueryValue=value;
				}
			}
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var oldValue = this.record;var newValue = value;this.record = value;
			
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					this.props.control.doModifiedEditor(oldValue, newValue);
				}
			}
			this.record = value;
		}
		else
		{
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;
			this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(this.props.dataField,newValue+"",oldValue+"");
			}
			this.updateModifiedTag();
		}
	}

	setValue(value,triggerModified = true)
	{
		if(value==0 || value)
		{
			if(Array.isArray(value))
			{
				$(this.inputField).selectpicker('val',value);
			}
			else
			{
				if(typeof(value) == 'string' && value.indexOf(',') != -1)
				{
					$(this.inputField).selectpicker('val',value.split(','));
					return;
				}
				let list = this.props.control.getProperty_DataProvider();
				for(let i = 0;i<list.length;i++)
				{
					let item = list[i];
					if(item.value == value || item.value == (value+""))
					{
						$(this.inputField).selectpicker('val',value);
						//$(this.inputField).val(value);
						this.setFinalValue(item.value,triggerModified);
						return;
					}
				}
			}
		}
		else
		{
			throw new Error("EnumEditor.setValue not String");
		}
	}

	setDisplayFieldText(value,triggerModify = true)
	{
		this.setValue(value,triggerModify);
	}
	setdeselectAll(){
		if(this.props.underQueryGroup){
			$(this.inputField).val('-点此填值-');
		}else{
			$(this.inputField).selectpicker('deselectAll');

		}
	}


	getFormAutoQueryValue()
	{
		var _text = this.getDisplayFieldText();
		if(Array.isArray(_text))
			_text = _text.join(",");
		_text = this.props.control.getQueryFilteredVaue(_text);
		return _text;
	}

	onMapEditorsHandler(selector,mapEditorValues,moduleInstanceId)
	{
		if((this.props.groupAlias == "" || !this.props.groupAlias) && this.props.moduleInstanceId == moduleInstanceId)
		{
			if(selector!="all" && this.props.xml.name != selector)
				return;
			if(this.props.underQueryGroup && !this.getInQueryGroupNow())
				return;
			//alert(this.record+"---------"+this.props.defaultValueForCMD);
			if(!this.record||this.record == "")
			{
				mapEditorValues[this.props.xml.name] = this.props.defaultValueForCMD;
			}
			else
			{
				let _record = this.record;
				if(Array.isArray(this.record))
				{
					_record = this.record.join(",");
				}
				mapEditorValues[this.props.xml.name] = _record;
			}
			
		}
		
	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		$(this.inputField).selectpicker('val','');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		this.inQueryGroup = false;
		
	}

	getSelectDom()
	{
		let _options = this.props.options;
		if(this.props.xml.Properties.Regular.Value){
			let regular =  this.props.xml.Properties.Regular.Value;
			let enumv = regular.split('|');
			var _optionsN =[];
			enumv.forEach((eItem)=>{
				_options.forEach((item)=>{
					if(Number(item.value)== eItem){
						_optionsN.push(item);
					}
				})
			})
		}
		if(this.props.underQueryGroup){
			if(_optionsN){
				if((_optionsN[0] && _optionsN[0].value != 'null' )|| !_optionsN[0]){
					
					_optionsN.unshift({label: '-只查空值-', value: 'null'});
				}
			}else{
				if((_options[0] && _options[0].value !='null') || !_options[0]){
					
					_options.unshift({label: '-只查空值-', value: 'null'});
				}
			}
		}
		if(_optionsN){
			var list = _optionsN.map(function(item){
				let _value = item.value;
				return <option key={_value} value={_value}>{item.label}</option>;
			});
		}else{
			var list = _options.map(function(item){
				let _value = item.value;
				return <option key={_value} value={_value}>{item.label}</option>;
			});
		}

		let _style={padding:'2px !important',height:(this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT)+'px'};
		if(this.props.cssStyle)
		{
			Object.assign(_style,this.props.cssStyle);
		}
		if(this.props.multiple && !this.props.dataField)
		{
			//selectpicker
			if(this.props.underQueryGroup){

				return <div><select multiple className="FormItemEnumEditor selectpicker form-control" data-live-search="true" ref={ node => this.inputField = node } id={"select"+this.props.xml.id} style={_style}
						onChange={this.selectedChanged.bind(this)} >
						{list}
						</select>
						<i className="fa fa-times-circle" ref={ node => this.inputFieldIcon = node } style={{position: 'relative',right: '25px',top:'3px',zIndex:'1000',fontSize:'1px',color:'gray'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
						</div>
			}else{
				return <select multiple className="FormItemEnumEditor selectpicker form-control" data-live-search="true" ref={ node => this.inputField = node } id={"select"+this.props.xml.id} style={_style}
	          		  	onChange={this.selectedChanged.bind(this)} >
                 	 	{list}
           			 </select>

			}
		}
		else
		{			
			if(this.props.underQueryGroup){
				return <div><select className="FormItemEnumEditor selectpicker form-control" data-live-search="true" ref={ node => this.inputField = node } id={"select"+this.props.xml.id} style={_style}
						onChange={this.selectedChanged.bind(this)} >
							{list}
						</select>
						<i className="fa fa-times-circle" ref={ node => this.inputFieldIcon = node } style={{position: 'relative',right: '25px',top:'3px',zIndex:'1000',fontSize:'1px',color:'gray'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
						</div>
			}else{
				return <select className="FormItemEnumEditor selectpicker form-control" data-live-search="true" ref={ node => this.inputField = node } id={"select"+this.props.xml.id} style={_style}
						onChange={this.selectedChanged.bind(this)} >
					  {list}
					</select>
			}

		}
	}

	render()
	{
		let inputWidth = this.props.displayLengthWidth + "px";
		
		let _display = this.currentDataFieldChanged?"block":"none";
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull)
			_notNullStyle['visibility']='hidden';
		
		let editorStyle = {display:'flex',flexDirection:'row',alignItems:'center',fontSize:"12px"};
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";

		let widthProValue = this.props.control.getProperty_Width();
	
	
		if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
		{
			editorStyle.width = "100%";
		}

		let labelStyle = {paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
		// if(this.state.underQueryGroup && !this.inQueryGroup)
		// {
		// 	labelStyle.cursor = "pointer";labelStyle.color = "#CFCFCF";
		// }
		if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"}
		let _selectDom = this.getSelectDom();
		return(
			<div id={this.props.xml.name} className='editorGroup' ref={ node => this.contextMenuHandler = node } style={editorStyle}>
			  <label htmlFor={"select"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node} style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
			  		 {this.state.label}	 
			  </label>
			  <i className='fa fa-snowflake-o' style={_notNullStyle}></i>
	          {_selectDom}
              <div style={{position:'relative',alignSelf:"stretch"}}>
              	<i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
              </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemEnumEditor.js